import React, { useState } from "react";
import { signUp } from "@aws-amplify/auth";
import { Link, useNavigate } from "react-router-dom";
import { FaGoogle, FaGithub, FaEye, FaEyeSlash } from "react-icons/fa";
import Layout from "../layout/Layout";
import toastr from "toastr";
import { v4 as uuidv4 } from "uuid"; // Import the UUID library
const RegisterPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const handleRegister = async (e) => {
    e.preventDefault();

    if (!email || !password || !confirmPassword) {
      toastr.error("All fields are required");
      return;
    }

    if (password !== confirmPassword) {
      toastr.error("Passwords do not match");
      return;
    }

    setLoading(true);
    try {
      const tenantID = uuidv4(); // Generate tenantID for v2 users

      // Call Cognito sign-up with tenantID
      await signUp({
        username: email,
        password,
        options: {
          userAttributes: {
            email,
            "custom:isVerified": "false",
            "custom:isAdmin": "false",
            "custom:billing_type": "Monthly",
            "custom:plan_name": "Basic",
            "custom:plan_price": "0",
            "custom:tenantID": tenantID, // v2: Use tenantID
          },
        },
      });

      // Call v2 API to create tenant
      const tenantApiUrl = process.env.REACT_APP_TENANT_API;
      const response = await fetch(`${tenantApiUrl}/createTenant`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          tenantID,
        }),
      });
      
      console.log(response);
      
      if (response.ok) {
        toastr.success("Account created successfully!");
      } else {
        toastr.warning(
          `Account created but failed to sync. Status: ${response.status}`
        );
      }

      toastr.success("Signup successful! Please confirm your email.");
      navigate("/confirm-email", { state: { email, tenantID } });
    } catch (error) {
      toastr.error(error.message || "Something went wrong during sign-up.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="position-absolute top-0 start-0 m-4 d-flex align-items-center">
        <img
          src="/images/odir-logo.png"
          alt="ODIR Logo"
          style={{ height: "40px", width: "auto" }}
        />
        <span className="ms-2 fw-bold" style={{ fontSize: "1.5rem", color: "#342ead" }}>ODIR</span>
      </div>
      <div className="container-fluid">
        <div className="row h-100">
          {/* Left Section */}
          <div className="col-lg-8 col-md-6 col-sm-12 position-relative d-flex align-items-center">
            <div className="text-center w-100 px-5">
              <h1 className="display-4 fw-bold mb-4" style={{ color: "#342ead" }}>
                Bringing Order to Your Cloud
              </h1>
              <p className="lead fs-4 text-muted">
                Optimize, secure, and visualize your multi-cloud environment with AI-powered insights and automation
              </p>
            </div>
          </div>

          {/* Right Section */}
          <div className="col-lg-4 col-md-6 col-sm-12 right-section">
            <div className="form mx-auto">
              <h3>Create an Account</h3>
              <p>Please sign up to your account and start the adventure</p>

              <form onSubmit={handleRegister}>
                <div className="mb-3">
                  <input
                    type="email"
                    id="email"
                    className="form-control"
                    placeholder="Email"
                    autoComplete="off"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>

                <div className="mb-3">
                  <div className="input-group">
                    <input
                      type={passwordVisible ? "text" : "password"}
                      id="password"
                      className="form-control"
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={togglePasswordVisibility}
                    >
                      {passwordVisible ? <FaEyeSlash /> : <FaEye />}
                    </button>
                  </div>
                </div>

                <div className="mb-3">
                  <input
                    type="password"
                    id="confirmPassword"
                    className="form-control"
                    placeholder="Confirm Password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                </div>

                <button
                  type="submit"
                  className="btn btn-Login-Signup w-100"
                  disabled={loading}
                >
                  {loading ? "Please Wait..." : "REGISTER"}
                </button>
              </form>

              <p className="mt-4 text-center">
                Already have an account? {" "}
                <Link to="/login" className="primary-text">
                  Login
                </Link>
              </p>

              <div className="centered-hr">
                <span>or</span>
              </div>

              <div className="social-icons d-flex justify-content-center">
                <a href="#" title="Sign Up with Google" style={{ color: "#DB4437" }}>
                  <FaGoogle />
                </a>
                <a href="#" title="Sign Up with GitHub" style={{ color: "#333" }}>
                  <FaGithub />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default RegisterPage;